import React, { useState } from "react";

export default function OurStory() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <section className="py-8 sm:py-12 md:py-8 bg-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg overflow-hidden shadow-sm">
          <div className="p-4 sm:p-6 md:p-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6 sm:mb-8 md:mb-12 text-indigo-700">
              Our Story
            </h2>
            <div className="max-w-3xl mx-auto">
              <div
                className={`relative transition-all duration-500 ease-in-out ${
                  isExpanded ? "max-h-[3000px]" : "max-h-48 sm:max-h-64 md:max-h-80"
                } overflow-hidden`}
              >
                <div className="space-y-3 sm:space-y-4 text-justify text-sm sm:text-base text-gray-600">
                  <p>
                    The Association of Gambian Students in India (GAM-IND) was
                    established in 2017, poised to contribute individually
                    and collectively on a platform to facilitate
                    development, training and awareness programs in a bid to
                    improve the quality and welfare of Gambian students in
                    India. The Association aims to synergize all Gambian students in India
                    under one umbrella and promote the culture of The Gambia in
                    India.
                  </p>
                  <p>
                    The Association collaborates with The Gambian
                    Embassy in Delhi, India to address pertinent issues
                    affecting the lives of Gambian students in India through a
                    wide range of socioeconomic initiatives. The
                    operational parameters involve organizing,
                    strengthening and consolidating national and bilateral
                    partnerships in capacity building activities appropriate for
                    self-empowerment and sustainable livelihood development.
                  </p>
                  <p>
                    GAM-IND makes efforts towards combating
                    negative vices affecting the lives of Gambian students,
                    which is given high priority on the agenda.
                    Positive actions are undertaken to complement both governments'
                    development blueprints through relentless efforts in addressing
                    development challenges towards meeting the goal of various
                    youth empowerment and educational programs crucial
                    to sustainable development.
                  </p>
                  {isExpanded && (
                    <>
                      <p>
                        The Association's activities are geared towards
                        capacity building as an engine for empowerment and
                        economic growth. GAM-IND is an independent,
                        apolitical (non-partisan) entity with no religious,
                        ethnic or any other socio-political inclination.
                        It is a charitable, non-profit making
                        organization engaged in fundraising,
                        lobbying and other development activities for
                        self-reliance.
                      </p>
                      <p>
                        The operational parameters involve
                        organizing, strengthening, and consolidating national
                        and bilateral partnerships in capacity-building
                        activities appropriate for self-empowerment and
                        sustainable livelihood development.
                      </p>
                      <p>
                        As a charitable, non-profit-making organization,
                        GAM-IND focuses on fundraising, lobbying, and other development
                        activities aimed at promoting self-reliance among
                        Gambian students in India.
                      </p>
                    </>
                  )}
                </div>
                {!isExpanded && (
                  <div className="absolute bottom-0 left-0 w-full h-16 sm:h-20 md:h-24 "></div>
                )}
              </div>
              <div className="text-center mt-4 sm:mt-6">
                <button
                  onClick={toggleExpand}
                  className="bg-blue-600 text-white px-4 sm:px-6 py-2 rounded-md hover:bg-blue-700 transition duration-300 ease-in-out text-sm sm:text-base"
                >
                  {isExpanded ? "See Less" : "See More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}